import React, { useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaFileLines, FaGraduationCap, FaUsers, FaClipboardList } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import "./FixedSidebars.css";

const FixedSidebars = ({ onFormOpen }) => {
  const [rightHovered, setRightHovered] = useState(null);
  const [leftHovered, setLeftHovered] = useState(null);
  const [mobileLeftOpen, setMobileLeftOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === "/";

  const rightSidebarItems = [
    {
      id: "scholarship-inside",
      icon: FaFileLines,
      label: "Scholarship Exam for Jack And Jill Matriculation School Student",
      shortLabel: "J&J Scholarship",
      action: () => onFormOpen("scholarship-inside"),
    },
    {
      id: "scholarship-outside",
      icon: FaFileLines,
      label: "Scholarship Exam for Other School Student",
      shortLabel: "Other School Scholarship",
      action: () => onFormOpen("scholarship-outside"),
    },
    {
      id: "alumni",
      icon: FaUsers,
      label: "Alumni Registration Form",
      shortLabel: "Alumni",
      action: () => window.location.href = "/alumni",
    },
    {
      id: "admission",
      icon: FaClipboardList,
      label: "Admission Query Form",
      shortLabel: "Admission",
      action: () => window.location.href = "/admission",
    },
  ];

  const leftSidebarItems = [
    {
      id: "facebook",
      icon: FaFacebook,
      label: "Facebook",
      url: "https://www.facebook.com/jackandjillschoolkabisthalam",
      color: "#1877F2",
    },
    {
      id: "instagram",
      icon: FaInstagram,
      label: "Instagram",
      url: "https://www.instagram.com/thejackandjillschool?igsh=YXg1NGxuZmtydzZw",
      color: "#E4405F",
    },
  ];

  return (
    <>
      <div className="fixed-sidebar fixed-sidebar-right">
        <div className="sidebar-container">
          {rightSidebarItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                className={`sidebar-item sidebar-item-right ${rightHovered === item.id ? "hovered" : ""}`}
                onMouseEnter={() => setRightHovered(item.id)}
                onMouseLeave={() => setRightHovered(null)}
                onClick={item.action}
                title={item.label}
                aria-label={item.label}
              >
                <div className="sidebar-icon-wrapper">
                  <Icon className="sidebar-icon" />
                </div>
                <span className="sidebar-label">{item.shortLabel}</span>
              </button>
            );
          })}
        </div>
      </div>

      {isHomePage && (
        <div className="fixed-sidebar fixed-sidebar-left">
          <div className="sidebar-container">
            {leftSidebarItems.map((item) => {
              const Icon = item.icon;
              return (
                <a
                  key={item.id}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`sidebar-item sidebar-item-left ${leftHovered === item.id ? "hovered" : ""}`}
                  onMouseEnter={() => setLeftHovered(item.id)}
                  onMouseLeave={() => setLeftHovered(null)}
                  title={item.label}
                  aria-label={item.label}
                  style={{ "--social-color": item.color }}
                >
                  <div className="sidebar-icon-wrapper">
                    <Icon className="sidebar-icon" />
                  </div>
                  <span className="sidebar-label">{item.label}</span>
                </a>
              );
            })}
          </div>
        </div>
      )}

      {isHomePage && (
        <button
          className={`mobile-fab mobile-fab-left ${mobileLeftOpen ? 'open' : ''}`}
          onClick={() => setMobileLeftOpen(!mobileLeftOpen)}
          aria-expanded={mobileLeftOpen}
          aria-label="Open social menu"
        >
          <FaFacebook className="fab-icon" />
        </button>
      )}

      {isHomePage && (
        <div className={`mobile-menu mobile-menu-left ${mobileLeftOpen ? 'open' : ''}`} role="menu">
          {leftSidebarItems.map((item) => {
            const Icon = item.icon;
            return (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mobile-menu-item"
                style={{ "--social-color": item.color }}
                onClick={() => setMobileLeftOpen(false)}
              >
                <div className="sidebar-icon-wrapper mobile">
                  <Icon className="sidebar-icon" />
                </div>
                <span className="mobile-menu-label">{item.label}</span>
              </a>
            );
          })}
        </div>
      )}

      <button
        className={`mobile-fab mobile-fab-right ${mobileRightOpen ? 'open' : ''}`}
        onClick={() => setMobileRightOpen(!mobileRightOpen)}
        aria-expanded={mobileRightOpen}
        aria-label="Open forms menu"
      >
        <FaFileLines className="fab-icon" />
      </button>

      <div className={`mobile-menu mobile-menu-right ${mobileRightOpen ? 'open' : ''}`} role="menu">
        {rightSidebarItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              className="mobile-menu-item"
              onClick={() => { item.action(); setMobileRightOpen(false); }}
            >
              <div className="sidebar-icon-wrapper mobile">
                <Icon className="sidebar-icon" />
              </div>
              <span className="mobile-menu-label">{item.shortLabel}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default FixedSidebars;
